import { HttpInterceptorFn } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { BYPASS_AUTHENTICATION_TOKEN } from '@share-auth-session';

const MOBILE_USER_AGENT_MARKER = 'Flutter';

export const mobileOriginInterceptor: HttpInterceptorFn = (req, next) => {
  if (!Capacitor.isNativePlatform() || req.context.get(BYPASS_AUTHENTICATION_TOKEN)) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers.set(
        'User-Agent',
        `${navigator.userAgent} ${MOBILE_USER_AGENT_MARKER}`,
      ),
    }),
  );
};
